import styled from 'styled-components'

interface InputProps {
  hasFiles: boolean;
  isIncorrect?: boolean;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  small {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #E84242;
  }
`

export const InputLabel = styled.span`
  &&& {
    color: #353744;
    font-weight: 900;
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 0;
  }
`

export const InputBox = styled.div<InputProps>`
  width: 100%;
  border: ${props => props.isIncorrect ? '1px solid #E84242' : props.hasFiles ? 'none' : '1px solid #C8C8C8'};
  background-color: ${props => props.hasFiles ? '#EBF2F2' : '#fff'};
  margin-top: 8px;
  padding: 5.5px 18px 5.5px 7px;
  display: flex;
  align-items: center;

  input {
    display: none;
  }

  button {
    background-color: #fff;
    min-width: 123px;
    border: 2px solid #3D6666;
    color: #3D6666;
    font-weight: 900;
    font-size: 14px;
    line-height: 21px;
    padding: 8px 18px;
  }

  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &&& div {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 auto 0 16px;

    svg {
      min-width: 20px;
      min-height: 20px;
      fill: #3D6666;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: ${props => props.hasFiles ? '#353744' : '#7B7C82'};
      margin: 0;
    }
  }

  button.file-picker-close-button {
    border: none;
    width: fit-content;
    height: fit-content;
    min-width: fit-content;
    color: #353744;
    background-color: inherit;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    
    svg {
      min-height: 20px;
      min-width: 20px;
    }
  }
  
`